export default __webpack_public_path__ + "static/media/ProximaNova-Extrabold.53156c58.otf";